import { render, staticRenderFns } from "./HomeAside.vue?vue&type=template&id=2aff86b8&scoped=true&"
import script from "./HomeAside.vue?vue&type=script&lang=js&"
export * from "./HomeAside.vue?vue&type=script&lang=js&"
import style0 from "./HomeAside.vue?vue&type=style&index=0&id=2aff86b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff86b8",
  null
  
)

export default component.exports